import VnrLink from '@components/VnrLink';
import React from 'react';

import styles from "./Breadcrumb.module.scss";

const BreadcrumbPagePost = ({ categories = [] }) => {
  if (categories.length === 0) {
    return (
      <div className={styles.vnrBreadcrumb}>
        <VnrLink href={"/"}>
          <span className={styles.breadcrumbItem}>
            Trang chủ
          </span>
        </VnrLink>
      </div>
    );
  };

  return (
    <div className={styles.vnrBreadcrumb}>
      <VnrLink href={"/"}>
        <span className={styles.breadcrumbItem}>
          Trang chủ
        </span>
      </VnrLink>
      {categories.map((c, index) => (
        <span key={`post_category_${index}`}>
            &nbsp;»&nbsp;
            <VnrLink to={c.url || ""}>
              <span
                className={styles.breadcrumbItem}
                dangerouslySetInnerHTML={{
                  __html: `${c.name}`,
                }}
              ></span>
            </VnrLink>
        </span>
      ))}
    </div>
  );
};
export default BreadcrumbPagePost;